import { NewsCategory } from '../@types/news';

function processSlug(slug: string) {
  if (slug === 'press-release') return 'press';
  return slug;
}

export function processTaxonomies(options: Array<NewsCategory> = []) {
  if (options.length > 0) {
    return options.map(n => ({
      label: n.name,
      value: processSlug(n.slug),
      url: `/${processSlug(n.slug)}`,
    }));
  }
  return [];
}
